import actions from './actions.js';
import getters from './getters.js';
import mutations from './mutations.js';

export default{
    namespaced: true,
    state(){
        return {
          lastFetch: null,
          userIsTherapist: false, 
            therapists: [
                {
                    id: 't1',
                    firstName: 'John',
                    lastName: 'Smith',
                    areas: ['adhd', 'anxiety', 'autism'],
                    description:
                      "I'm Dr.Smith and I've worked as a therapist for years. Let me help you.",
                    hourlyRate: 30
                  },
                  {
                    id: 't2',
                    firstName: 'Julie',
                    lastName: 'Jones',
                    areas: ['depression', 'did', 'anxiety'],
                    description:
                      "I'm Julie and I've worked as a therapist for 23 years. I have my own clinic ready for availability",
                    hourlyRate: 45
                  },
            ],
        }
    },
    mutations,
    getters,
    actions
};